module.exports = __webpack_public_path__ + "static/img/bg3.9e648b3e.png";